import React, { useEffect, useState, useRef } from 'react'
import Autosuggest from 'react-autosuggest';
import { Provider, useDispatch, useSelector } from 'react-redux';
import actions from '../../../../Redux/Action';
import Select from 'react-select'
import { toast } from 'react-toastify';
const ExtendedHoursSCSearch = (props) => {
  const dispatch = useDispatch()
  const refOne = useRef(null);
  const { handleExtendedHourSCData, ExtendedHourSCData, location, setFilterSaller, setSelectedOptions, setSelectedServices } = props
  
  let [suggestions, setSuggestions] = useState([])
  const [clearInput, setClearInput] = useState(false);
  const [activearrow, setActivearrow] = useState(false)
  let [copySuggestions, setCopySuggestions] = useState([])
  const reftwo = useRef(null)
  const [activearrow2, setActivearrow2] = useState(false)
  const [City, setCity] = useState([])
  let state = useSelector((state) => state.ServiceReducer.StateCity_SVC) || []
  //let state = useSelector((state) => state.ServiceReducer.state) || []
  //let City = useSelector((state) => state.ServiceReducer.GetCitySPL) || {}
  // ///for product filter
  // const [taggleMenu, setToggleMenu] = useState(false);
  // const [servicelist, setservicelist] = useState([]);
  // const [selectedServices, setSelectedServices] = useState([]);
  // const [filteredData, setFilteredData] = useState(servicelist);
  // const [selectedOptions, setSelectedOptions] = useState([]);
  // const allowedMenus = ['Air Conditioner', 'Washing Machine', 'Refrigerator'];
  // const ProductMenus = (ChildMenus && ChildMenus.length ? ChildMenus.filter((item) => allowedMenus.includes(item.ChildMenuTitle)) : []);

  useEffect(() => {
    if (state && !Object.keys(state).length) {
      dispatch(actions.ServiceAction.GetState())
      dispatch(actions.ServiceAction.GetStateCity_SVC())
    }
  }, [])

  useEffect(() => {
    document.addEventListener('click', handleOnClickOutSide, true)
  }, [])
  const handleOnClickOutSide = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setActivearrow(false)
    }
    if (reftwo.current && !reftwo.current.contains(e.target)) {
      setActivearrow2(false)
    }
  }


  
  const handleClearInput = (e) => {
    e && e.preventDefault();
    setClearInput(false);
    handleExtendedHourSCData('City', '')
  }

  const SearchServiceLocationList = (e, flag = false) => {
    e && e.preventDefault()
    let error = {}

    if (!ExtendedHourSCData.lat && (!ExtendedHourSCData.State || ExtendedHourSCData.State == '')) error.State = 'Please select state'

    if (( ExtendedHourSCData.State && (!ExtendedHourSCData.City || ExtendedHourSCData.City == '')) || (( (!ExtendedHourSCData.City || ExtendedHourSCData.City == '')))) error.City = 'Please select city'

    // if ((!ExtendedHourSCData.product || ExtendedHourSCData.product == '')) error.product = 'Please select Produt'
    handleExtendedHourSCData('error', error)
    if (!Object.keys(error).length) {
      let data = {
        "State":ExtendedHourSCData.State || '',
        "City": ExtendedHourSCData.City || '',
      }
     
      dispatch(actions.ServiceAction.GetSVCExtendedWorkingHours(data, (res) => {
        //setservicelist(res.Entity);
     
        handleExtendedHourSCData('', '', { SelectedcSeller: null, searchPincode: '' })
        if (res.IsSuccess) {
          if (res.Entity && res.Entity.length) setFilterSaller(res.Entity || [])
          else !flag && toast.warning('Data not found');
        } else toast.error(res.Message);
      }))

    }
  }
  const handleSelect = (e) => {
    let { name, value } = e.target
    delete ExtendedHourSCData.error[name]
    handleExtendedHourSCData([name], value)
  }
  const handleReactSelect = (selectedOption, name) => {
    //const { label , value } = selectedOption
    let value = selectedOption && selectedOption.value || ''
    delete ExtendedHourSCData.error[name]
    if (name == 'State') {
        let stateData =  (state && state.length && state.find(d => d.State === value)?.City.split(',').map(c => c.trim())) || [];
        //   state && state.length ? state.find(item=>item.State === value).City :[]
        console.log(selectedOption, name,'handleReactSelect',stateData) 
        setCity(stateData)
      //dispatch(actions.ServiceAction.GetCitySPL({ 'StateName': value }))
      handleExtendedHourSCData('', '', { [name]: value, City: '', selectedState: selectedOption, selectedCity: null, selectedCityLocation: null })
    } else if (name == 'City') {
      let selectedCityLocation = City && City.length && City.filter(item => item.City === value)[0]
      handleExtendedHourSCData('', '', { [name]: value, selectedCity: selectedOption, selectedCityLocation })
    }
    else handleExtendedHourSCData('', '', { [name]: value, selectedProduct: selectedOption })
    dispatch(actions.ServiceAction.ResetSVCExtendedWorkingHours([]))
  }
  return (
    <div className='search-location-wrapper px-3'>
      <div className="row center-xs bottom-xs">
        <div className="col-md-3 col-xs-12  mt-2 mb-4">
          <div className="box ">
            <p className="material-input">
              <Select
                className={`material-input-field f-16 text-left ${ExtendedHourSCData.error.State ? 'is-invalid' : ''}`}
                placeholder="Select State"
                onChange={selectedOption => handleReactSelect(selectedOption, 'State')}
                value={ExtendedHourSCData.selectedState || null}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="State"
                options={state && state.length ? state.map((item) => { return { 'value': item.State, 'label': item.State } }) : []}
              />
            </p>
            <div className="invalid-feedback d-block">
              {ExtendedHourSCData.error.State || ''}
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xs-12  mt-2 mb-4">
          <div className="box ">
            <p className="material-input">
              <Select
                className={`material-input-field f-16 text-left ${ExtendedHourSCData.error.State ? 'is-invalid' : ''}`}
                placeholder="Select City"
                onChange={selectedOption => handleReactSelect(selectedOption, 'City')}
                value={ExtendedHourSCData.selectedCity || null}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="City"
                options={City && City.length ? City.map((item) => { return { 'value': item, 'label': item } }) : []}

              />
            </p>
            <div className="invalid-feedback d-block">
              {ExtendedHourSCData.error.City || ''}
            </div>
          </div>
        </div>
       
        <div className="col-md-2 col-lg-1 col-xs-12 text-center  mb-4">
          <div className="box">
            <a className="next cta cta--contained cta--black cta--icon px-5" id="open-modal" href='' onClick={SearchServiceLocationList}>SEARCH</a>
          </div>
        </div>
      </div>
     
    </div>
  )
}

export default ExtendedHoursSCSearch